import {getThemeRawLogo} from "../../services/color";
import React from "react";
import styled from "styled-components";
import T from "../../services/language";
import {hexToRgbA} from "../../services/app";

export default function BookingLoading(props) {
    return (

        <Content>
            <Image>
                {
                    !!getThemeRawLogo() ? (<img src={getThemeRawLogo()}/>) : null
                }
            </Image>
            <Spin>
                <div className="dot-flashing"></div>
            </Spin>
            <Text>{T("Hold on, we are getting \nthe schedule ready")}</Text>
        </Content>
    )
}

const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 16px;
    margin-top: 40px;
    margin-bottom: 40px;
    position: fixed;
    z-index: 10;
    top: 32px;
    left: 0;
    background-color: white;
    width: 100%;
    height: calc(100% - 70px);
    overflow: auto;
`;
const Image = styled.div`
    img, svg {
        width: 180px;
        margin-bottom: 16px;
        object-fit: contain;
    }
`;
const Text = styled.div`
    font-size: 15px;
    line-height: 24px;
    color: ${props => props.theme.text || "#939393"};
    margin-top: 16px;
    text-align: center;
    white-space: pre-wrap;
`;
const Spin = styled.div`

    .dot-flashing {
        position: relative;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: ${props => props.theme.main || "#40A68C"};
        color: ${props => props.theme.main || "#40A68C"};
        animation: dot-flashing 1s infinite linear alternate;
        animation-delay: 0.5s;
    }

    .dot-flashing::before, .dot-flashing::after {
        content: "";
        display: inline-block;
        position: absolute;
        top: 0;
    }

    .dot-flashing::before {
        left: -15px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: ${props => props.theme.main || "#40A68C"};
        color: ${props => props.theme.main || "#40A68C"};
        animation: dot-flashing 1s infinite alternate;
        animation-delay: 0s;
    }

    .dot-flashing::after {
        left: 15px;
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: ${props => props.theme.main || "#40A68C"};
        color: ${props => props.theme.main || "#40A68C"};
        animation: dot-flashing 1s infinite alternate;
        animation-delay: 1s;
    }

    @keyframes dot-flashing {
        0% {
            background-color: ${props => props.theme.main || "#40A68C"};
        }
        50%, 100% {
            background-color: ${props => hexToRgbA(props.theme.main || "#40A68C", 0.2)};
        }
    }
`;

